
// constant parameters 
// masses
const mass_of_proton = 1.007276466583; // amu 
const mass_of_neutron = 1.00866491590; // amu 
const mass_of_electron = 5.48579909065 * (10 ** -4); // amu
// conversion factor
const conversion_amu_MeV = 931.493614838934; // amu to MeV
// liquid drop model parameters
const aV = 15.75; // MeV
const aS = 17.80; // MeV
const aC = 0.711; // MeV
const aA = 23.7; // MeV
const aP = 11.18; // MeV
// exporting variables
export { mass_of_proton, mass_of_neutron, mass_of_electron, conversion_amu_MeV, aV, aS, aC, aA, aP };

